import type { CourseHearing, CourseHearingAttempt } from '@teachur/http-client';

// The attempt that best represents a hearing row in the admin table.
// Prefer the server-computed open attempt (currentAttempt); when the hearing is
// finished (graded/cancelled) there is no open attempt, so fall back to the most
// recent attempt so the table can still show its date, instructor and video call.
export const getLatestHearingAttempt = (
  hearing: CourseHearing | null | undefined
): CourseHearingAttempt | null => {
  if (!hearing) return null;
  if (hearing.currentAttempt) return hearing.currentAttempt;

  const attempts = hearing.attempts ?? [];
  if (attempts.length === 0) return null;

  return [...attempts].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
};
